import React from 'react';
import '../../assets/iconfont/iconfont.css';

export default function Icon({ icon, className, style, ...restProps }) {
  const classes = ['iconfont', `icon-${icon}`, className].join(' ');
  return <i className={classes} {...restProps} style={Object.assign({ display: 'inline-block' }, style)} />;
}
